export default "__VITE_ASSET__CHk$Vn$W__"